import PathFindingVisualizer from './PathVisualizer/PathFindingVisualizer';

function App() {
  return (
    <PathFindingVisualizer> </PathFindingVisualizer>
  );
}

export default App;
